import { ApolloProvider as ExternalApolloProvider } from "@apollo/client";
import type { ReactNode } from "react";

import { useApolloErrorMessages } from "@shared/data/client/useApolloErrorMessages/useApolloErrorMessages";

import { useClient } from "./useClient";

interface Props {
  children: ReactNode;
}

const ApolloProvider = ({ children }: Props) => {
  useApolloErrorMessages();
  const client = useClient();

  return <ExternalApolloProvider client={client}>{children}</ExternalApolloProvider>;
};
export { ApolloProvider };
